export default function BasketInternal(
    BasketStorage,
    BasketJar,
    BasketFactory
) {
    var fn = this;

    fn.init = function () {
        const storage = BasketStorage.init();

        // Remove/filter periods which is in past sense
        BasketJar.currentBookings = storage.bookings.filter((booking) => {
            return !BasketFactory.CheckPeriodDateIsExpired(booking.BookingEnd); // if not expired
        });

        // update storage (expirery update)
        BasketStorage.setBookingsStorage(BasketJar.currentBookings);

        BasketJar.activity = storage.activity;
        BasketJar.location = storage.location;
    };

    return fn;
}
